import React from "react";
import {
  Modal,
  TextInput,
  Button,
  Checkbox,
  Grid,
  NumberInput,
  ActionIcon,
} from "@mantine/core";
import { useSetState } from "@mantine/hooks";
import { IconX } from "@tabler/icons";
import { apiWithInterceptor } from "../../../../api";
import { showNotification } from "@mantine/notifications";

const CreateSectionModal = ({ opened, setOpenSectionModal, theaterId }) => {
  const [sectionInfo, setSectionInfo] = useSetState({
    name: "",
    vip: false,
    // price: 0,
    rows: [{ number_of_seats: parseInt(0) }],
  });

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => {
          setOpenSectionModal(false);
        }}
        title="Create new section"
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            apiWithInterceptor
              .post(`/section`, {
                theater_id: theaterId,
                name: sectionInfo.name,
                vip: sectionInfo.vip,
                // price: sectionInfo.price,
                rows: sectionInfo.rows,
              })
              .then((res) => {
                console.log(res);
                showNotification({
                  title: "Success",
                  message: "Section created successfully",
                  color: "green",
                });

                setOpenSectionModal(false);
                setSectionInfo({ name: "", vip: false, price: 0, rows: [] });
              })
              .catch((err) => {
                showNotification({
                  title: "Error",
                  message: "Section creation failed",
                  color: "red",
                });
                console.log(err);
              });
          }}
        >
          <Grid>
            <Grid.Col xs={6}>
              <TextInput
                // label="Section Name"
                placeholder="Enter the section name"
                value={sectionInfo.name}
                onChange={(e) => {
                  setSectionInfo({ name: e.target.value });
                }}
              />
            </Grid.Col>
            <Grid.Col xs={6}>
              <Checkbox
                label="VIP Section"
                size="xl"
                checked={sectionInfo.vip}
                onChange={(e) => {
                  setSectionInfo({ vip: e.target.checked });
                }}
              />
            </Grid.Col>
            {/* <Grid.Col>
              <NumberInput
                min={0}
                hideControls
                label="Section Price"
                placeholder="Enter the section price"
                value={sectionInfo.location}
                onChange={(e) => {
                  setSectionInfo({ price: e });
                }}
              />
            </Grid.Col> */}

            {sectionInfo.rows.map((row, index) => {
              return (
                <Grid.Col>
                  <TextInput
                    key={index}
                    label={`Row ${index + 1} number of seats`}
                    value={row.number_of_seats}
                    onFocus={(e) => {
                      e.target.select();
                    }}
                    onChange={(e) => {
                      setSectionInfo(
                        (sectionInfo.rows[index].number_of_seats = parseInt(
                          e.target.value
                        ))
                      );
                    }}
                    placeholder="Set the number of seats in this row"
                    rightSection={
                      <ActionIcon
                        onClick={() => {
                          if (sectionInfo.rows.length > 1) {
                            setSectionInfo({
                              rows: sectionInfo.rows.filter(
                                (row, i) => i !== index
                              ),
                            });
                          } else if (sectionInfo.rows.length === 1) {
                            showNotification({
                              title: "Failed to remove row",
                              message: "You must have at least 1 row",
                              color: "red",
                            });
                          }
                        }}
                      >
                        <IconX />
                      </ActionIcon>
                    }
                  />
                </Grid.Col>
              );
            })}
            <Grid.Col>
              <Button
                onClick={() => {
                  setSectionInfo({
                    rows: [...sectionInfo.rows, { number_of_seats: 0 }],
                  });
                }}
                variant="outline"
              >
                Add new row
              </Button>
            </Grid.Col>
            <Grid.Col xs={12}>
              <Button style={{ width: "100%" }} type="submit">
                Create Section
              </Button>
            </Grid.Col>
          </Grid>
        </form>
      </Modal>
    </>
  );
};

export default CreateSectionModal;
